module.exports = __webpack_public_path__ + "assets/img/mecha-btn-2bf3febc.png";